<template>

  <v-app v-if="!$route.meta.anonymousAuth && ['/'].indexOf($route.path) < 0">
    <core-toolbar color="primary" dark>
      <template slot="toolbar-avatar">
        <v-app-bar-nav-icon color="white" @click.stop="clickDrawer" data-cy="toolbar-icon">
        </v-app-bar-nav-icon>
        <v-avatar style="cursor: pointer" @click="gotoHome" max-height="50px" size="100" class="ml-3" tile>
          <v-img src="assets/imgs/logo-inverted.svg" width="100%" height="100%" contain data-cy="toolbar-img" />
        </v-avatar>
      </template>

      <template slot="toolbar-title">
        &nbsp;
      </template>
      <template slot="toolbar-drawer">
        &nbsp;
      </template>

      <template slot="toolbar-after-spacer">
        <div class="ml-auto mr-0" v-if="portalBloqueado">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-chip color="warning" v-on="on">
                <v-icon small class="mr-2">ph-warning</v-icon>
                Portal Bloqueado
              </v-chip>
            </template>
            <span data-cy="tooltip-text">Não é possível realizar inclusões e alterações de dados!</span>
          </v-tooltip>
        </div>
      </template>
    </core-toolbar>

    <!--<core-menu :mini-variant.sync="mini" permanent></core-menu>-->
    <core-menu></core-menu>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <router-view :key="$route.fullPath"></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app>
        <v-row class="justify-center">
          <span class="px-4">&copy; {{ new Date().getFullYear() }} - Money Plus</span>
        </v-row>
      </v-footer>
    </slot>
  </v-app>

  <IndexLayout v-else></IndexLayout>
</template>

<style lang="sass">
  @import 'assets/styles/styles.scss'
</style>

<script>
export default {
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout')
  },
  data () {
    return {
      mini: false,
    }
  },
  computed: {
  //  mini: {
  //    get () {
  //      return this.$store.state.estruturadas.mini
  //    },
  //    set (value) {
  //      this.$store.commit('estruturadas/mini', value)
  //    }
  //  }
  // },
    portalBloqueado () {
      return JSON.parse(localStorage.empresa).portalIndicadorBloqueio
    }
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
    clickDrawer () {
      this.$store.commit('drawer')
      this.mini = !this.mini
    }
  }
}
</script>
